module.exports = __webpack_public_path__ + "img/bg.99eb6bf5.jpg";